import clone from 'lodash/clone';

export function shallowMerge<T extends object = object>(
    parent: object = {},
    child: object = {},
    conflictKeys: (keyof T)[] = [],
): T {
    const mergedChild = clone(child);
    Object.keys(parent).forEach((key) => {
        // 对于冲突的key，以child值为准
        // 如：parent有solidFill，child有gradFill，这个时候不需要赋值solidFill到child
        if (conflictKeys.includes(key as keyof T)
            && conflictKeys.some(conflictKey => child[conflictKey as string] !== undefined)
        ) {
            return;
        }

        mergedChild[key] = child[key] ?? parent[key];
    });

    return mergedChild as T;
}
